export default __webpack_public_path__ + "static/media/id_nb.080ac4b3.webp";